import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconGif$1 = /*@__PURE__*/ proxyCustomElement(class WppIconGif extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-gif", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M15.4 3C16.8359 3 18 4.16406 18 5.6V14.0021C18 15.438 16.8359 16.6021 15.4 16.6021H4.6C3.16406 16.6021 2 15.438 2 14.0021V5.6C2 4.16406 3.16406 3 4.6 3H15.4ZM15.4 4.2H4.6C3.8268 4.2 3.2 4.8268 3.2 5.6V14.0021C3.2 14.7753 3.8268 15.4021 4.6 15.4021H15.4C16.1732 15.4021 16.8 14.7753 16.8 14.0021V5.6C16.8 4.8268 16.1732 4.2 15.4 4.2ZM6.81168 7.29712C7.2892 7.29712 7.62682 7.36218 8.01342 7.54783C8.26235 7.66737 8.36724 7.96607 8.2477 8.215C8.12816 8.46392 7.82945 8.56881 7.58053 8.44927C7.34066 8.33409 7.14881 8.29712 6.81168 8.29712C6.11831 8.29712 5.60883 8.93421 5.60883 9.79501C5.60883 10.6566 6.11898 11.2958 6.81168 11.2958C7.15458 11.2958 7.44486 11.1519 7.59588 10.8952L7.6008 10.8832V10.296L7.30017 10.2965C7.04914 10.2965 6.84131 10.1115 6.8056 9.87041L6.80017 9.79652C6.80017 9.54548 6.98518 9.33765 7.22629 9.30194L7.30017 9.29652H8.10146C8.3525 9.29652 8.56032 9.48153 8.59604 9.72263L8.60146 9.79652L8.60039 11.0347L8.5953 11.0789L8.57837 11.1508L8.56198 11.1949C8.26085 11.907 7.56925 12.2958 6.81168 12.2958C5.51086 12.2958 4.60883 11.1656 4.60883 9.79501C4.60883 8.42489 5.51071 7.29712 6.81168 7.29712ZM10.5032 7.39471C10.7542 7.39471 10.962 7.57972 10.9977 7.82083L11.0032 7.89471V11.7044C11.0032 11.9806 10.7793 12.2044 10.5032 12.2044C10.2521 12.2044 10.0443 12.0194 10.0086 11.7783L10.0032 11.7044V7.89471C10.0032 7.61857 10.227 7.39471 10.5032 7.39471ZM12.8998 7.39471L14.4977 7.40023C14.7739 7.40119 14.997 7.62582 14.996 7.90196C14.9951 8.15299 14.8094 8.36018 14.5682 8.39506L14.4943 8.40023L13.3976 8.396V9.7992L14.296 9.79989C14.547 9.79989 14.7549 9.98489 14.7906 10.226L14.796 10.2999C14.796 10.5509 14.611 10.7588 14.3699 10.7945L14.296 10.7999L13.3976 10.7992L13.3981 11.6915C13.3981 11.9426 13.2131 12.1504 12.972 12.1861L12.8981 12.1915C12.647 12.1915 12.4392 12.0065 12.4035 11.7654L12.3981 11.6915V7.89299C12.3989 7.64195 12.5847 7.43476 12.8259 7.39988L12.8998 7.39471Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-gif-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-gif", "wpp-icon-gif-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-gif-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-gif-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconGif$1);
      }
      break;
  } });
}

const WppIconGif = WppIconGif$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconGif, defineCustomElement };
